import React from "react";

interface Item {
  label: React.ReactNode;
  value: string;
}
interface OptionProps {
  label: React.ReactNode;
  items: Item[];
  onClick: (event: string) => void;
}

export const Option: React.FC<OptionProps> = ({ label, items, onClick }) => {
  return (
    <div>
      <div className="flex justify-start items-center font-normal flex-1 gap-2 p-2">
        {label}
      </div>
      {items &&
        items.map((item, index) => (
          <p
            className="p-2 cursor-pointer hover:bg-gray-100"
            onClick={() => {
              onClick(item.value);
            }}
            key={index}
          >
            {item.label}
          </p>
        ))}
    </div>
  );
};
